import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AccountBookService {
  private apiUrl = '/accountbooks';
  private apiSpringUrl = '/spring/accountbooks';

  constructor(private http: HttpService) { }

  get(query?: any, ownerId?: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}?ownerId=${ownerId}`;
    return this.http.get(url, query);
  }

  getBookYearMonthAll(staccountbookId?: number): Promise<any> {
    let url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/all`;
    if (staccountbookId !== undefined) {
      url = `${url}?staccountbookId=${staccountbookId}`
    }
    return this.http.get(url);
  }

  getBookYearMonth(ownerId: number, staccountbookId?: number): Promise<any> {
    let url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/${ownerId}`;
    if (staccountbookId !== undefined) {
      url = `${url}?staccountbookId=${staccountbookId}`
    }
    return this.http.get(url);
  }

  execute(jsonData: any): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/execute`;
    return this.http.put(url, jsonData);
  }

  confirm(jsonData: any): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/confirm`;
    return this.http.put(url, jsonData);
  }

  commit(jsonData: any): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/commit`;
    return this.http.put(url, jsonData);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/account-book/account-book.service.ts